import Vue from 'vue'
import moment from 'moment'

Vue.filter('fixed', (value: { toFixed: (arg0: number) => void; }) => {
  if (value) {
    return value.toFixed(1)
  }
})

Vue.filter('dtol', (value: string | number | void | moment.Moment | Date | (string | number)[] | moment.MomentInputObject | undefined) => {
  // @ts-ignore
	const date = moment(value)
  return date.format('ddd DD MMM')
})

Vue.filter('dtos', (value: string | number | void | moment.Moment | Date | (string | number)[] | moment.MomentInputObject | undefined) => {
  // @ts-ignore
	const date = moment(value)
  return date.format('DD/MM/YYYY')
})

Vue.filter('dtoh', (value: string | number | void | moment.Moment | Date | (string | number)[] | moment.MomentInputObject | undefined) => {
  // @ts-ignore
	const date = moment(value)
  return date.format('HH:mm')
})

Vue.filter('itoa', (value: { toFixed: (arg0: number) => { toString: () => void; }; }) => {
  return value.toFixed(2).toString()
})

Vue.filter('stomn', (value: number) => {
  return Math.ceil(value / 60)
})

Vue.filter('mtokm', (value: number) => {
  if (value) {
    if ((value / 1000) % 1 === 0) return value / 1000
    return (value / 1000).toFixed(1)
  }
})

Vue.filter('firstLetter', (value: any) => {
  const letters = {...value}
  return letters[0].toUpperCase()
})

Vue.filter('getInitialWithDot', (value: any) => {
  if(value) {
    return value[0].toUpperCase() + "."
  } else {
    return null
  }
})

Vue.filter('firstLetterToUppercase', (value: any) => {
  if(value) {
    value = value.toLowerCase()
    return value.charAt(0).toUpperCase() + value.slice(1)
  } else {
    return null
  }
})

Vue.filter('gender', (value: any) => {
  if(value === "male") {
    return "M."
  } else if (value === "female") {
    return "Mme"
  }
})

Vue.filter('order-status', (value: any) => {
  if(value === "pending") {
    return "En attente"
  } else if (value === "verified") {
    return "Payée"
  } else if (value === "verification_failed") {
    return "Échec"
  } else if (value === "failed") {
    return "Échec"
  }
})

Vue.filter('type', (value: any) => {
  if(value === "admin") {
    return "Administrateur"
  } else if (value === "owner") {
    return "Propriétaire"
  } else if (value === "manager") {
    return "Gestionnaire de biens"
  } else if (value === "professional") {
    return "Prestataire"
  } else {
    return null
  }
})

Vue.filter('type-sm', (value: any) => {
  if(value === "admin") {
    return "Administrateur"
  } else if (value === "owner") {
    return "Propriétaire"
  } else if (value === "manager") {
    return "Gestionnaire"
  } else if (value === "professional") {
    return "Prestataire"
  } else {
    return null
  }
})

Vue.filter('access-type', (value: any) => {
  if(value === "owner") {
    return "Propriétaire"
  } else if (value === "family") {
    return "Famille"
  } else if (value === "tenant") {
    return "Locataire"
  } else if (value === "other") {
    return "Autre"
  } else {
    return null
  }
})

Vue.filter('price-in-euros', (value: any) => {
  const string = value.toString()
  const beginning = string.slice(0, string.length - 2)
  const end = string.slice(string.length - 2, string.length)
  return beginning + "," + end
})

Vue.filter('highlight', (words: { replace: (arg0: RegExp, arg1: string) => void; }, query: RegExp) => {
  const pattern = new RegExp(query, 'gi')
  return words.replace(pattern, '<mark class="highlight-output">' + '$&' + '</mark>')
})
